<div class="modal-backdrop" (click)="onBackdropClick()">
  <div class="modal-panel" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 class="modal-title">{{ header }}</h3>
      <button class="modal-close" type="button" (click)="onCloseClick()" aria-label="Fermer"><mat-icon>close</mat-icon></button>
    </div>

    <div class="modal-body">
      <ng-container *ngIf="!msgIsHtml; else htmlTpl">{{ msg }}</ng-container>
      <ng-template #htmlTpl><div [innerHTML]="msg"></div></ng-template>
    </div>

    <div class="modal-actions">
      <button
        #actionBtn
        *ngFor="let label of list"
        type="button"
        class="action"
        [attr.autofocus]="i === defaultIdx ? '' : null"
        (click)="onChoose(label)"
      >{{ label }}</button>
    </div>
  </div>
</div>
